/**
 * Tenant helpers — namespace localStorage keys per empresa so that switching
 * companies never bleeds persisted preferences from another tenant.
 */

const FALLBACK_ID = 'default';

/** localStorage key written by storageService when the user selects a company */
const EMPRESA_STORAGE_KEY = 'senciyo_empresa_id';

/**
 * Returns the current empresaId used to namespace localStorage keys.
 * Reads from `senciyo_empresa_id` (set by storageService on login/workspace selection);
 * falls back to 'default' so the app never crashes when no session exists.
 */
export function ensureEmpresaId(): string {
  try {
    const id = localStorage.getItem(EMPRESA_STORAGE_KEY);
    if (id && id.trim()) return id.trim();
  } catch {
    // storage access can throw in sandboxed environments
  }
  return FALLBACK_ID;
}

/**
 * Returns a namespaced localStorage key: `${empresaId}:${key}`
 */
export function lsKey(key: string): string {
  return `${ensureEmpresaId()}:${key}`;
}
